module.exports = DDC.BuiltModules["html-react-parser"]["0.4.7"];


//////////////////
// WEBPACK FOOTER
// external "DDC.BuiltModules[\"html-react-parser\"][\"0.4.7\"]"
// module id = 41
// module chunks = 0